import * as React from "react";
import { useTransactionUploadV2 } from "@iliotech/data-wire/src/stores";
import { Typography } from "@progress/kendo-react-common";
import s from "./Cells.module.scss";
import cn from "classnames";
import { TransactionTableCellProps } from "./DateCell";
import { observer } from "mobx-react-lite";

const CustodianCell = ({ index }: TransactionTableCellProps) => {
  const store = useTransactionUploadV2();

  const custodian = store.equities.getField("custodian", index + "") as string;
  const custodianResolved = store.equities.getField(
    "custodianResolved",
    index + ""
  ) as boolean;

  if (!custodian || !custodianResolved) {
    return (
      <Typography.p
        className={cn(s.link, s.error)}
        onClick={() =>
          store.equities.setCustodianModal({
            visible: true,
            id: index + "",
            replace: true,
          })
        }
      >
        Resolve {custodian ? `[${custodian}]` : "Account"}
      </Typography.p>
    );
  }
  return (
    <Typography.p
      className={cn(s.link, s.black)}
      onClick={() =>
        store.equities.setCustodianModal({
          visible: true,
          id: index + "",
          replace: false,
        })
      }
    >
      {custodian}
    </Typography.p>
  );
};

export default observer(CustodianCell);
